var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_11249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2949 12.6064V18.4156H23.2578C22.9082 20.2838 21.8589 21.8657 20.2851 22.9293L25.0871 26.7066C27.8849 24.0885 29.499 20.243 29.499 15.6748C29.499 14.6112 29.4049 13.5883 29.23 12.6066L15.2949 12.6064Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00449 18.1885L5.92146 19.029L2.08789 22.0562C4.5225 26.9516 9.51242 30.3335 15.2963 30.3335C19.2911 30.3335 22.6403 28.9971 25.0884 26.7063L20.2865 22.9289C18.9683 23.8289 17.2869 24.3745 15.2963 24.3745C11.4493 24.3745 8.18085 21.7426 7.01053 18.1971L7.00449 18.1885Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08709 8.61084C1.07833 10.6289 0.5 12.9063 0.5 15.3335C0.5 17.7608 1.07833 20.0381 2.08709 22.0562C2.08709 22.0697 7.01021 18.1834 7.01021 18.1834C6.71429 17.2834 6.53938 16.3289 6.53938 15.3334C6.53938 14.3378 6.71429 13.3833 7.01021 12.4833L2.08709 8.61084Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2966 6.30625C17.4756 6.30625 19.4125 7.06987 20.9594 8.54263L25.1964 4.2472C22.6273 1.81996 19.2915 0.333496 15.2966 0.333496C9.51272 0.333496 4.5225 3.70169 2.08789 8.61082L7.01086 12.4836C8.18102 8.93807 11.4496 6.30625 15.2966 6.30625Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_11249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.260ba97c9fd5be2343a96b4dfb28eb9d.svg";
export { ForwardRef as ReactComponent };